import { useState } from 'react';
import { audioManager } from '../audio/AudioManager';

/**
 * AudioUnlocker — "Discover" button that captures the user's first
 * interaction to satisfy browser autoplay policy, then starts audio.
 */
export default function AudioUnlocker() {
  const [visible, setVisible] = useState(true);
  const [unlocking, setUnlocking] = useState(false);

  const handleClick = async () => {
    setUnlocking(true);
    await audioManager.unlockAll();
    audioManager.start();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#1a1a2e]/90 backdrop-blur-md">
      <div className="text-center max-w-sm px-8">
        {/* Logo */}
        <div className="text-8xl mb-6">🏠</div>

        <h1 className="font-display text-4xl font-extrabold text-white mb-2 tracking-tight">
          discover<span className="text-festival-gold">house</span>music
        </h1>

        <p className="text-white/50 text-sm mb-2">
          A new city every Friday. Walk the streets, find the sound.
        </p>

        <p className="text-festival-sky text-xs mb-8 font-medium">
          🎵 5 tracks · 2 districts · Summer Festival Opening
        </p>

        {/* Discover button */}
        <button
          onClick={handleClick}
          disabled={unlocking}
          className="w-full py-4 px-8 bg-festival-gold hover:bg-amber-500 active:scale-95
                     text-[#1a1a2e] font-display font-bold text-xl rounded-2xl
                     transition-all duration-200 shadow-lg shadow-festival-gold/30
                     disabled:opacity-50 disabled:cursor-wait"
        >
          {unlocking ? 'Loading...' : '🔊 Discover'}
        </button>

        <p className="text-white/30 text-xs mt-4">
          Click to enable audio · WASD to walk
        </p>
      </div>
    </div>
  );
}
